var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3190_4879)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99851 3.74948L4.74034 9.11514C4.5059 9.34958 4.37419 9.66755 4.37419 9.9991C4.37419 10.3307 4.5059 10.6486 4.74034 10.8831C4.97478 11.1175 5.29276 11.2492 5.62431 11.2492C5.95586 11.2492 6.27383 11.1175 6.50827 10.8831L11.7664 5.51741C12.2352 5.04861 12.4986 4.41278 12.4986 3.74979C12.4986 3.0868 12.2352 2.45097 11.7664 1.98217C11.2976 1.51337 10.6618 1.25 9.99883 1.25C9.33584 1.25 8.70001 1.51337 8.23121 1.98217L2.99491 7.32596C2.64207 7.6731 2.36146 8.08666 2.16925 8.54279C1.97704 8.99891 1.87705 9.48859 1.87503 9.98355C1.87302 10.4785 1.96902 10.969 2.15751 11.4267C2.34599 11.8844 2.62323 12.3002 2.97323 12.6502C3.32323 13.0002 3.73906 13.2774 4.19674 13.4659C4.65442 13.6544 5.14489 13.7504 5.63986 13.7484C6.13482 13.7464 6.6245 13.6464 7.08062 13.4542C7.53675 13.262 7.95031 12.9813 8.29745 12.6285L13.5338 7.28471",
    stroke: "#6A7282",
    strokeWidth: 1.24986,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3190_4879"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.9984,
    height: 14.9984,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatFile);
export default __webpack_public_path__ + "static/media/ChatFile.b4112340e3f7cbb3c7b5d6cd11c38201.svg";
export { ForwardRef as ReactComponent };